/** 是否按 4G 表处理：后端通讯类型为 4G，或当前/厂商表号以 YJ 开头（不区分大小写） */
export function isDevice4GMeter(device) {
  if (!device) return false;
  if (Number(device.communication_type) === 0) return true;
  const yjPrefix = (s) => String(s ?? '').trim().toUpperCase().startsWith('YJ');
  return yjPrefix(device.current_meter_no) || yjPrefix(device.factory_meter_no);
}
